import { Link } from 'react-router';
import { TriangleAlert } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useSessionState } from '@/auth';
import { messages } from '@/i18n';
import { AuthScreenLayout } from './AuthScreenLayout';

export function AuthError() {
  const { error, refetch } = useSessionState();

  return (
    <AuthScreenLayout title={messages.authError.title}>
      <Alert variant="destructive">
        <TriangleAlert aria-hidden />
        <AlertDescription>
          <p>{messages.authError.body}</p>
          {import.meta.env.DEV && error ? (
            <pre className="mt-2 overflow-x-auto text-xs opacity-80">{error.message}</pre>
          ) : null}
        </AlertDescription>
      </Alert>
      <div className="mt-4 flex flex-col gap-2">
        <Button onClick={refetch}>{messages.common.retry}</Button>
        <Button asChild variant="outline">
          <Link to="/sign-in">{messages.common.backToSignIn}</Link>
        </Button>
      </div>
    </AuthScreenLayout>
  );
}
